import { defineRecipe } from '@chakra-ui/react';
import { getTokenValueOrString } from '../utils';

export type ThemeGenButtonConfig = {
  borderRadius: number;
  padding?: number;
  width?: number | string;
  maxWidth?: number | string;
  minWidth?: number | string;
};

export function generateButtonRecipe(config?: ThemeGenButtonConfig) {
  return defineRecipe({
    base: {
      textAlign: 'center',
      color: 'white',
      borderRadius: getTokenValueOrString(config?.borderRadius, 'px'),
      padding: getTokenValueOrString(config?.padding, 'px')
    },
    variants: {
      strictWidth: {
        true: {
          width: getTokenValueOrString(config?.width, 'px')
        }
      },
      toggled: {
        true: {
          boxShadow: 'inset 0 2px 6px rgba(0,0,0,0.5)',
          filter: 'brightness(0.95)'
        },
        false: {
          transition: 'all 0.2s ease'
        }
      },
      variant: {
        primary: {
          maxWidth: getTokenValueOrString(config?.maxWidth, 'px'),
          minWidth: getTokenValueOrString(config?.minWidth, 'px'),
          backgroundColor: 'primary.500',
          _hover: {
            backgroundColor: 'primary.200'
          },
          _active: {
            backgroundColor: 'primary.500'
          }
        },
        secondary: {
          maxWidth: getTokenValueOrString(config?.maxWidth, 'px'),
          minWidth: getTokenValueOrString(config?.minWidth, 'px'),
          backgroundColor: 'secondary.500',
          _hover: {
            backgroundColor: 'secondary.200'
          },
          _active: {
            backgroundColor: 'secondary.500'
          }
        },
        tertiary: {
          maxWidth: getTokenValueOrString(config?.maxWidth, 'px'),
          minWidth: getTokenValueOrString(config?.minWidth, 'px'),
          backgroundColor: 'tertiary.500',
          _hover: {
            backgroundColor: 'tertiary.200'
          },
          _active: {
            backgroundColor: 'tertiary.500'
          }
        }
      },
      tableAction: {
        true: {
          backgroundColor: 'transparent',
          borderColor: 'secondary.500',
          _hover: {
            backgroundColor: 'secondary.100'
          }
        }
      },
      tabButton: {
        active: {
          height: 'fit-content',
          padding: '4px 16px',
          backgroundColor: 'rgb(198, 246, 213)',
          color: 'rgb(39, 103, 73)',
          borderRadius: 'full',
          _hover: {
            backgroundColor: 'rgb(223, 254, 233)'
          }
        },
        inactive: {
          height: 'fit-content',
          padding: '4px 16px',
          backgroundColor: 'white',
          color: 'black',
          borderRadius: 'full',
          _hover: {
            backgroundColor: 'rgb(223, 254, 233)',
            color: 'rgb(39, 103, 73)'
          }
        },
        disabled: {
          height: 'fit-content',
          padding: '4px 16px',
          backgroundColor: 'white',
          color: 'gray',
          cursor: 'not-allowed',
          borderRadius: 'full',
          _hover: {
            backgroundColor: 'white',
            color: 'gray'
          }
        }
      },
      submitButton: {
        true: {
          bg: 'primary.500'
        }
      },
      cancelButton: {
        true: {
          bg: 'white'
        }
      },
      clearButton: {
        true: {
          bg: 'secondary.500'
        }
      },

      toolbarButton: {
        true: {
          color: 'gray.900',
          backgroundColor: 'white',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderColor: 'gray.200',
          _hover: {
            backgroundColor: 'secondary.50'
          }
        }
      },
      iconButton: {
        true: {
          width: 'fit-content',
          maxWidth: undefined,
          minWidth: undefined
        }
      }
    },
    defaultVariants: {
      variant: 'primary'
    }
  });
}
